import React, { useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import moment from "moment";

import { H4, P } from "../../atoms/Texts";
import { CustomSelectDropdown } from "../../atoms/Inputs";
import { PrimaryButton } from "../../atoms/Buttons";
import CustomCalendar from "../../atoms/CustomCalendar";
import { selectStyle } from "../../../shared/fixtures/select_style";
import {
  hours,
  timeOptions,
  timezones,
} from "../../../shared/helpers/utils.dummydata";
export const CreateScheduleFormTwo = ({
  fields,
  loading,
  onCreateSchedule,
  closeModal,
}) => {
  const [selectedDate, setSelectedDate] = useState("");

  const onChangeDate = (date) => {
    setSelectedDate(date);
  };

  const tileDisabled = ({ date, view }) => {
    if (view === "month") {
      // Check if a date React-Calendar wants to check is on the list of disabled dates
      return moment(date).isBefore(moment(), "day");
    }
  };

  const formCtx = useFormContext();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = formCtx;

  const onSubmit = (data) => {
    // const date = moment(selectedDate).format("MM-DD-YYYY");
    const time = `${data.time.value}  ${data.timezone.value}`;
    const duration = data.duration.value;

    onCreateSchedule({ date: selectedDate, time, duration });
  };
  return (
    <div className="pb-20">
      <form className="" onSubmit={handleSubmit(onSubmit)}>
        <H4
          fontSize="26px"
          fontFamily="regular"
          color="#22202D"
          className="text-center mb-10"
        >
          Schedule a meeting with John
        </H4>
        <div className="flex">
          <div className="md:w-1/2">
            <P color="#7D7B96" fontSize="14px" smallSize="14px" className="mb-1">
              Select a date
            </P>
            <CustomCalendar onChange={onChangeDate} tileDisabled={tileDisabled} />
          </div>
          {selectedDate && (
            <div className="md:w-1/2 md:pl-10">
              <P color="#7D7B96" fontSize="14px" smallSize="14px" className="mb-1">
                Select active time
              </P>
              <div>
                <label htmlFor={`service`}>
                  <P
                    fontSize="14px"
                    fontFamily="semi"
                    color="#47495C"
                    className="mb-2"
                  >
                    Duration
                    <span
                      className=""
                      style={{
                        color: "#E62250",
                      }}
                    >
                      *
                    </span>
                  </P>
                </label>

                <Controller
                  control={control}
                  id="duration"
                  rules={{
                    required: "Select meeting duration",
                  }}
                  name="duration"
                  render={({ field }) => (
                    <CustomSelectDropdown
                      {...field}
                      styles={selectStyle}
                      className="w-1/2"
                      options={hours}
                    />
                  )}
                />

                <ErrorMessage
                  errors={errors}
                  name="duration"
                  as={
                    <P fontSize="12px" className="-mt-2 mb-4 text-red-400 text-sm" />
                  }
                />
              </div>
              <div className="flex gap-x-6 mt-6">
                <div className="w-1/2">
                  <label htmlFor={`service`}>
                    <P
                      fontSize="14px"
                      fontFamily="semi"
                      color="#47495C"
                      className="mb-2"
                    >
                      Time
                      <span
                        className=""
                        style={{
                          color: "#E62250",
                        }}
                      >
                        *
                      </span>
                    </P>
                  </label>
                  <Controller
                    control={control}
                    id="time"
                    rules={{
                      required: "Select meeting time",
                    }}
                    name="time"
                    render={({ field }) => (
                      <CustomSelectDropdown
                        {...field}
                        styles={selectStyle}
                        options={timeOptions}
                      />
                    )}
                  />

                  <ErrorMessage
                    errors={errors}
                    name="time"
                    as={
                      <P
                        fontSize="12px"
                        className="-mt-2 mb-4 text-red-400 text-sm"
                      />
                    }
                  />
                </div>

                <div className="w-1/2">
                  <label htmlFor={`service`}>
                    <P
                      fontSize="14px"
                      fontFamily="semi"
                      color="#47495C"
                      className="mb-2"
                    >
                      Time Zone
                      <span
                        className=""
                        style={{
                          color: "#E62250",
                        }}
                      >
                        *
                      </span>
                    </P>
                  </label>
                  <Controller
                    control={control}
                    id="timezone"
                    rules={{
                      required: "Select timezone",
                    }}
                    name="timezone"
                    render={({ field }) => (
                      <CustomSelectDropdown
                        {...field}
                        styles={selectStyle}
                        options={timezones}
                      />
                    )}
                  />

                  <ErrorMessage
                    errors={errors}
                    name="timezone"
                    as={
                      <P
                        fontSize="12px"
                        className="-mt-2 mb-4 text-red-400 text-sm"
                      />
                    }
                  />
                </div>
              </div>

              <PrimaryButton disabled={loading} className="w-full mt-10">
                Schedule meeting
              </PrimaryButton>
            </div>
          )}
        </div>
      </form>
    </div>
  );
};
